import Vue from 'vue'
import moment from 'moment'

Vue.filter('sqlDate', str => {
  return !str || str === '0000-00-00' ? 'na' : moment(str).format('DD/MM/YYYY')
})

Vue.filter('unixToDateString', timestamp => {
  return Number(timestamp) ? moment.unix(Number(timestamp)).format('DD/MM/YYYY') : ''
})

Vue.filter('currency', value => {
  if (typeof value !== 'number' || isNaN(value)) return '-'
  let sign = value < 0 ? '-' : ''
  return `${sign}$${Math.abs(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
})

Vue.filter('fieldType', value => {
  return value && value.length ? 'is-danger' : ''
})

Vue.filter('distance', value => {
  let km = Number(value)
  if (km < 1) {
    return `${(km * 100).toFixed(0)}m`
  } else if (km < 10) {
    return `${km.toFixed(1)}km`
  } else {
    return `${km.toFixed(0)}km`
  }
})
